import React, {useState} from "react";
import Typography from "@material-ui/core/Typography";
import "./FindProductsForm.css";

const FindProductsForm = ({email, onChange, onSubmitCallback}) => {
    const [updating, setUpdating] = useState(false);

    const performContactUpdate = async (event) => {
        event.preventDefault();
        setUpdating(true);

        await onSubmitCallback();
    };

    return (
        <React.Fragment>
            <form onSubmit={ performContactUpdate }>
                <div className="mt-25">
                    <Typography variant="body1" gutterBottom>
                        What is the email of the customer for which you want to swap the product?
                    </Typography>
                    <div>
                        <div className="mt-10 mb-50">
                            <input className="find-products-form-input" required type="email" value={email}
                                   onChange={e => onChange(e.target.value)}/>
                        </div>
                    </div>
                </div>
                <div className="mt-50">
                    <button className="button save-btn accent"
                            disabled={updating}>
                        Find Products
                    </button>
                </div>
            </form>
        </React.Fragment>
    );
};

export default FindProductsForm;